<div class="accordion-list-item-container" (click)="toggleAccordion()">
  <div class="content {{ open ? 'extended' : '' }}">
    <div class="heading">
      <div class="headingtext">{{ item.key }}</div>
      <div class="icon">
        <img src="./assets/ui/shared/icons/minimize_accordion_icon.svg" *ngIf="open" alt="close_accordion_icon" title="close_accordion_icon" />
        <img src="./assets/ui/shared/icons/expand_accodion_icon.svg" *ngIf="!open" alt="open_accordion_icon" title="open_accordion_icon" />
      </div>
    </div>
    <div class="body">
     <markdown [data]="item.value"></markdown>
    </div>
  </div>
</div>
